import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import Store from '../../Store';
import Sidebar, { Props } from '../_components/Sidebar';
import { OnViewerResize, OnSetIsFullWidth } from '../../Viewer/_actions/ViewerActions';
import { OnLayerListVisibility } from '../../LayerList/_actions/LayerListActions';
import { OnModuleCreatorClose } from '../../ModuleCreator/_actions/ModuleCreatorActions';

const mapStateToProps = (store:Store, props:Props) => ({
	viewerHeight			: store.getIn(['create','viewer','height']),
	windowWidth				: store.getIn(['create','window','width']),
	previewFabricEnabled	: store.getIn(['create','tools','previewFabric','enabled']),
	moduleCreatorOpened		: store.getIn(['create', 'moduleCreator', 'opened']),
	layerListOpened			: store.getIn(['create', 'layerList', 'opened']),
});

const mapDispatchToProps = (dispatch:Dispatch, props:Props) => ({
	resizeViewer	: (width:number, height:number)	=> dispatch(OnViewerResize(width, height)),
	setIsFullWidth	: (isFullWidth:boolean)			=> dispatch(OnSetIsFullWidth(isFullWidth)),
	onLayerListVisibility: (visible:boolean) => dispatch(OnLayerListVisibility(visible)),
	onModuleCreatorClose: () => dispatch(OnModuleCreatorClose())
});

export default connect(mapStateToProps, mapDispatchToProps)(Sidebar);